import { format } from 'date-fns'
import isNil from 'lodash-es/isNil'

import { CALENDAR_GRID_LABEL_SEPARATOR } from '../../../constants/calendarGrid'
import { DATE_FULL_FORMAT_FROM_TIME } from '../../../constants/date'
import { toUkTimezoneDate } from '../../../utils/date'
import { AppointmentFollowUpAction } from '../Appointment.constants'

export function getAppointmentFollowUpRequestLabel(request) {
  return [request.number, request.title].join(CALENDAR_GRID_LABEL_SEPARATOR)
}

export function getAppointmentFollowUpDateLabel({ date, timezone }) {
  return isNil(date)
    ? null
    : format(toUkTimezoneDate(date, timezone), DATE_FULL_FORMAT_FROM_TIME)
}

export function getAppointmentFollowUpBeforeKey(prompt) {
  return isNil(prompt.current_due_date)
    ? 'Appointment.CouplingBeforeNoneKey'
    : 'Appointment.CouplingBeforeKey'
}

export function getAppointmentFollowUpReasonKey(prompt) {
  return prompt.restore_job_enabled
    ? 'Appointment.CouplingReasonRestoreKey'
    : 'Appointment.CouplingReasonPlainKey'
}

export function getAppointmentFollowUpApplyData(prompt) {
  return {
    action: AppointmentFollowUpAction.apply,
    expected_current_due_date: prompt.current_due_date,
  }
}
